// src/sectors/pilates/settings/tabs/AccountSecurityTab.jsx
import React from 'react';
import Divider from '@mui/material/Divider';

import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import MDTypography from 'components/MDTypography';
import MDInput from 'components/MDInput';

import { SectionCard, TabActions } from '../ui/SettingsUi';

export function AccountSecurityTab() {
  const [draft, setDraft] = React.useState({
    username: '',
    oldPassword: '',
    newPassword: '',
    newPassword2: '',
  });
  const [saving, setSaving] = React.useState(false);
  const [dirty, setDirty] = React.useState(false);
  const [error, setError] = React.useState('');

  const patch = (k, v) => {
    setDraft((p) => ({ ...p, [k]: v }));
    setDirty(true);
  };

  const onReset = () => {
    setDraft({ username: '', oldPassword: '', newPassword: '', newPassword2: '' });
    setDirty(false);
    setError('');
  };

  const onSave = async () => {
    setError('');

    if (draft.newPassword || draft.newPassword2 || draft.oldPassword) {
      if (!draft.oldPassword || !draft.newPassword) {
        setError('Şifre değiştirmek için eski ve yeni şifre gerekli.');
        return;
      }
      if (draft.newPassword !== draft.newPassword2) {
        setError('Yeni şifreler eşleşmiyor.');
        return;
      }
      if (draft.newPassword.length < 6) {
        setError('Yeni şifre en az 6 karakter olmalı.');
        return;
      }
    }

    setSaving(true);
    try {
      // TODO: authApi.updateUsername(draft.username)
      // TODO: authApi.changePassword({ oldPassword: draft.oldPassword, newPassword: draft.newPassword })
      await new Promise((r) => setTimeout(r, 450));
      setDirty(false);
      setDraft((p) => ({ ...p, oldPassword: '', newPassword: '', newPassword2: '' }));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Container maxWidth="md" sx={{ py: { xs: 1.25, md: 2 } }}>
      <Box sx={{ display: 'grid', gap: 1.5 }}>
        {error ? (
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Chip
              size="small"
              color="error"
              variant="outlined"
              label={error}
              sx={{ borderRadius: '999px', fontWeight: 900 }}
            />
          </Box>
        ) : null}

        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <Box sx={{ width: '100%', maxWidth: 760 }}>
            <SectionCard icon="person" title="Hesap" subtitle="Kullanıcı adı ve şifre işlemleri">
              <Box sx={{ display: 'grid', gap: 1.25, maxWidth: 520 }}>
                <MDInput
                  label="Kullanıcı adı (username)"
                  value={draft.username}
                  onChange={(e) => patch('username', e.target.value)}
                />

                <Divider sx={{ my: 1 }} />

                <MDTypography variant="button" fontWeight="bold">
                  Şifre Değiştir
                </MDTypography>

                <MDInput
                  label="Eski Şifre"
                  type="password"
                  value={draft.oldPassword}
                  onChange={(e) => patch('oldPassword', e.target.value)}
                />
                <MDInput
                  label="Yeni Şifre"
                  type="password"
                  value={draft.newPassword}
                  onChange={(e) => patch('newPassword', e.target.value)}
                />
                <MDInput
                  label="Yeni Şifre (Tekrar)"
                  type="password"
                  value={draft.newPassword2}
                  onChange={(e) => patch('newPassword2', e.target.value)}
                />
              </Box>
            </SectionCard>
          </Box>
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <Box sx={{ width: '100%', maxWidth: 760 }}>
            <TabActions saving={saving} dirty={dirty} onReset={onReset} onSave={onSave} />
          </Box>
        </Box>
      </Box>
    </Container>
  );
}
